<template>
  <span
    class="highlight-template"
    data-test="highlight-template"
  >
    <div v-if="visible">
      <div
        class=""
        v-html="flashcardTemplate"
      >
      </div>
      <template
        v-for="(item, index) in choices"
      >
        <span
          :id="choiceIdentifier(index + 1)"
          :key="item.id"
        >
          <span
            class="highlight"
            :class="{ selected: answerIds.includes(item.id)}"
            :data-test="`answer-choice-${item.id}`"
            @click="handleChoiceClick(item)"
          >
            {{ item.text }}
          </span>
        </span>
      </template>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    answerIds() {
      return this.flashcardState?.answerIds || [];
    },
    choices() {
      return [...this.flashcard.answers].sort((a, b) => a.sortOrder - b.sortOrder);
    },
    flashcardTemplate() {
      let template = this.flashcard.question;

      this.flashcard.question.match(/\{\{[^\}]+\}\}/g).forEach( (match) => {
        const identifier = match.replace(/[\{\}\s]/g, '');
        const m = RegExp(`\{\{ *${identifier} *\}\}`);
        template = template.replace(m, `<span id="container-${identifier}"></span>`);
      });

      return template;
    },
  },
  watch: {
    async $route() {
      this.visible = false;
      await this.$nextTick();
      this.visible = true;
      await this.$nextTick();
      this.arrangeChoices();
    },
  },
  mounted() {
    this.$nextTick(this.arrangeChoices);
  },
  methods: {
    arrangeChoices() {
      for (let id = 1; id <= this.choices.length; id++) {
        const highlightIdentifier = `highlight-${id}`;
        const containerIdentifier = `container-${highlightIdentifier}`;

        const highlightElement = document.getElementById(highlightIdentifier);
        const containerElement = document.getElementById(containerIdentifier);

        if( highlightElement && containerElement ) {
          if( highlightElement.parentNode !== containerElement ) {
            containerElement.appendChild(highlightElement);
          }
        }
      }
    },
    handleChoiceClick(item) {
      const currentAnswers = this.flashcardState?.answerIds && [...this.flashcardState.answerIds] || [];
      if (currentAnswers.includes(item.id)) {
        currentAnswers.splice(currentAnswers.indexOf(item.id), 1);
      } else {
        currentAnswers.push(item.id);
      }
      this.$emit('answers-selected', currentAnswers);
    },
    choiceIdentifier(id) {
      return `highlight-${id}`;
    },
  },
};
</script>

<style lang='scss'>
  .highlight-template {

    .highlight:hover {
      background-color: #fbf9dd !important;
    }
    .selected, .selected:hover {
      background-color: #F9F3A4 !important;
    }
  }
</style>
